import React from "react";
//#region redux
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { TimeReportingBannerProps } from "models/propTypes/timeReportingPropTypes";
import { DisplayType } from "models/enums/style";
//#endregion
//#region components
import { Banner, BannerField } from "components/common";
import { Divider, Grid } from "@mui/material";
import { useSalaryPermissions } from "components/salary";
//#endregion
import { LocalizationHelperInstance, UnitsHelper } from "utils/helpers";
import TimeReportHelperInstance from "components/timeReporting/timeReportHelper";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const TimeReportingBanner: React.FC<TimeReportingBannerProps> = (props) => {
  const { compHours, internalHours, billableHours, absenceHours } = props;

  const { isSalaryDeviationsAvailable } = useSalaryPermissions();

  const getTotal = () => {
    const total = billableHours + absenceHours + internalHours;
    return getDisplayValue(total);
  };

  const getDisplayValue = (value: number) => {
    return UnitsHelper.getTimeWithHoursSuffix(TimeReportHelperInstance.formatHours(value));
  };

  return (
    <Banner title={props.title ?? ""} icon={IconDefinitionConstants.WTimer} type={DisplayType.Info}>
      <Grid container direction="column" spacing={3} className={cssExports.timeReportingBannerContainer}>
        <Grid item>
          <Divider className={clsx(cssExports.sectionSeparator, cssExports.verticalSection)}></Divider>
        </Grid>
        <Grid item container spacing={3}>
          <Grid item>
            <BannerField
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.WorkedHours)}
              value={getTotal()}
            ></BannerField>
          </Grid>
          {isSalaryDeviationsAvailable && (
            <Grid item>
              <BannerField
                label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.ExpectedComp)}
                value={getDisplayValue(compHours)}
              ></BannerField>
            </Grid>
          )}

          <Grid item>
            <BannerField
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.DeviatingTime)}
              value={getDisplayValue(absenceHours)}
            ></BannerField>
          </Grid>
          <Grid item>
            <Divider
              orientation={"vertical"}
              className={clsx(cssExports.sectionSeparator, cssExports.horizontalSection)}
            ></Divider>
          </Grid>
          <Grid item>
            <BannerField
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.BillableTime)}
              value={getDisplayValue(billableHours)}
            ></BannerField>
          </Grid>
          <Grid item>
            <BannerField
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.InternalTime)}
              value={getDisplayValue(internalHours)}
            ></BannerField>
          </Grid>
        </Grid>
      </Grid>
    </Banner>
  );
};

export default TimeReportingBanner;
